import { useEffect } from 'react';
import { useStore } from '../store/store';
import { startUndoCapture } from './undoCapture';

// Cycle de vie de la capture do/undo. Indépendant de la collaboration (l'undo
// marche en solo) : démarré dès qu'un document est ouvert, repart d'un
// historique vide, s'arrête au changement de document.
export const useUndoHistory = () => {
  const documentId = useStore((s) =>
    s.currentDocument.type === 'template'
      ? s.currentDocument.id
      : s.currentProposal.id
  );

  useEffect(() => {
    if (!documentId) return undefined;
    const { pushUndoEntry, clearUndoHistory } = useStore.getState();
    return startUndoCapture(useStore, pushUndoEntry, clearUndoHistory);
  }, [documentId]);
};
